import React from 'react';
import Layout from '../../components/Layout';
import ReviewPage from './ReviewPage';

const title = 'Leave a review — BestHand';

function action() {
  return {
    title,
    description: 'Love BestHand? Leave a review on the App Store, Google Play, or Google. It takes less than a minute.',
    component: (
      <Layout>
        <ReviewPage />
      </Layout>
    ),
  };
}

export default action;
